export enum CollectionType {
  General = 'general',
  Wishlist = 'wishlist'
}
